import { Route } from 'react-router-dom';
import Layout from '../components/layout';
import Coupon from '../Pages/Coupon/Coupon';
import AddCoupon from '../Pages/Coupon/AddCoupon';
import ProtectedRoute from '../components/ProtectedRoute';

export const CouponRoute = ({ menuActive, setMenuActive }) => (
  <>
    <Route path="/coupon" element={
      <ProtectedRoute>
        <Layout activePage='coupon' menuActive={menuActive} setMenuActive={setMenuActive}>
          <Coupon />
        </Layout>
      </ProtectedRoute>
    } />
    <Route path="/add-coupon" element={
      <ProtectedRoute>
        <Layout activePage='coupon' menuActive={menuActive} setMenuActive={setMenuActive}>
          <AddCoupon />
        </Layout>
      </ProtectedRoute>
    } />
    <Route path="/coupon/:couponId" element={
      <ProtectedRoute>
        <Layout activePage='coupon' menuActive={menuActive} setMenuActive={setMenuActive}>
          <AddCoupon />
        </Layout>
      </ProtectedRoute>
    } />
  </>
);
